export enum ViewAccountOnly {
  YES = 1,
  NO = 7,
}
